import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useForm from 'components/FormUse';
import Loading from 'components/Loading';
import LoginService from 'services/Login/service';
import { passwordValidation } from 'config/utils';
import './style.scss';
import { recaptcha } from 'config';
import useScript from '../../hooks/useScript'
import TermPolCheckbox from 'components/TermPolCheckbox';


const FormRegister = ({ processData = null }) => {

    useScript(`https://www.google.com/recaptcha/enterprise.js?render=${recaptcha.site_key}`);
    window.onSubmit = () =>{
        document.getElementById("btn-submit").click();
    }
     //erick
    const [btnDisabledAccept,setBtnDisabled]= useState("btn-disabled");
    const [checkboxState, setCheckboxState] = useState({
        privacyPoliciesChecked: false,
       termConditionsChecked: false,
       legalOthersChecked: false,  // Nuevo estado

      });
    const [selectedDocumentType, setSelectedDocumentType] = useState('');

    const handleCheckboxClick = (isChecked,checkboxName) => {
        setCheckboxState(prevState => {
            const updatedState = {
                ...prevState,
                [checkboxName]: isChecked,
            };
            
    
            if (updatedState.privacyPoliciesChecked && updatedState.termConditionsChecked) {
                setBtnDisabled("")


            } else {
                setBtnDisabled("btn-disabled")

            }
    
            return updatedState;
        });
    
       
      };
    
   
    
    

    

    const [isLoading, setIsLoading] = useState(false);
    const [errorProcess, setErrorProcess] = useState('');
    const removeRegularExp = (strText = '') => {
        //strText = strText.replaceAll('@', '');
        return strText;
    }
    const {
        handleSubmit,
        handleChange,
        data,
        errors,
    } = useForm({
        validations: {
            first_name: {
                required: {
                    value: true, 
                    message: "Ingrese un nombre"
                }
            },
            email: {
                pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Ingrese un email válido"
                }
            }, 
            ...passwordValidation,
          
        },
        onSubmit: async (data) => {
            setIsLoading(true);
            try{
               
                let encripterResp = await LoginService.authEncrypter({
                    'password': data.password
                });

                let token = document.getElementsByName('g-recaptcha-response')[0].value;
                let preRegisterResp = await LoginService.authPreRegister({                    
                    'email': data.email, 
                    'password': encripterResp.payload, 
                    'firstName': data.first_name, 
                    'lastName': data.last_name,
                    "platform": recaptcha.platform,
                    'token': token, 
                });
                if(!preRegisterResp || !preRegisterResp.payload || preRegisterResp.internalCode!=='200'){
                    console.error(preRegisterResp);
                    let msgError = 'Ha ocurrido un error en el proceso, vuelva a intentar.';
                    if(preRegisterResp && preRegisterResp.payload){
                        msgError = preRegisterResp.payload.includes('already')?'El correo ya se encuentra registrado, pruebe <a href="/login"><b>Iniciar Sesión</b></a> o la opción <a href="/lost-password"><b>Olvidé Mi Contraseña</b></a>.':preRegisterResp.payload;
                    }
                    setErrorProcess(msgError);
                    setIsLoading(false);
                    return;
                }

                await LoginService.authToken({
                    user: preRegisterResp.payload
                });
                processData && processData(2, {user:preRegisterResp.payload},checkboxState,
                    {additionalData:{documentCode:selectedDocumentType,documentNumber:data.nro_documento}});
            }catch(error){
                console.error(error);
            }
        },
        initialValues: {
            first_name: '', 
            last_name: '', 
            email: '', 
            password: '', 
            password_confirm: '', 
            nro_documento:'',

        }
    });

    return (
        <>
        <form onSubmit={handleSubmit}>
        <div className="form-group">
                <label className="label-select">Tipo de Documento</label>
                <select
                value={selectedDocumentType}
                onChange={(e) => setSelectedDocumentType(e.target.value)}
                disabled={false}
                className='custom-select'
                >
                <option value=""  >Seleccione...</option>
                <option value="1" >DNI</option>
                <option value="4" >Pasaporte</option>
                <option value="5" >RUC</option>
                <option value="2" >CI</option>
                <option value="3" >CE</option>
                <option value="9" >Sin-Doc-Id</option>
                <option value="0" >Otros</option>
                {/* Agrega más opciones según sea necesario */}
                </select>
                
            </div>
            <div className="form-group">
                <input value={data.nro_documento || ''} onChange={handleChange('nro_documento')} required maxLength="50" type="text" className="form-control" name="textBoxDocumento" id="textBoxDocumento" placeholder="N° Documento" />
                {errors.nro_documento && <p className="error-form">{errors.nro_documento}</p>}
            </div>
            <div className="form-group">
                <input value={data.first_name || ''} onChange={handleChange('first_name')} required maxLength="50" type="text" className="form-control" name="textBoxNombres" id="textBoxNombres" placeholder="Nombres" />
                {errors.first_name && <p className="error-form">{errors.first_name}</p>}
            </div>
            <div className="form-group">
                <input value={data.last_name || ''} onChange={handleChange('last_name')} required maxLength="50" type="text" className="form-control" name="textBoxApellidos" id="textBoxApellidos" placeholder="Apellidos" />
                {errors.last_name && <p className="error-form">{errors.last_name}</p>}
            </div>
            <div className="form-group">
                <input value={data.email || ''} onChange={handleChange('email')} required maxLength="150" type="email" className="form-control" name="textBoxEmail" id="textBoxEmail" placeholder="Correo electrónico" />
                {errors.email && <p className="error-form">{errors.email}</p>}
            </div>
            <div className="form-group">
                <input value={data.password || ''} onChange={handleChange('password', null, removeRegularExp)} required maxLength="20" type="password" className="form-control" name="textBoxPassword" id="textBoxPassword" placeholder="Contraseña" />
                {errors.password && 
                    (errors.password.html ? 
                        <div className="password-requirements">
                            <span className="password-requirements-description">La contraseña debe tener: </span>
                            <ul className="password-requirements-list" dangerouslySetInnerHTML={{__html: errors.password.html}}></ul>
                        </div>
                        :
                        <p className="error-form">{errors.password}</p>
                    )
                }
            </div>
            <div className="form-group mb-4 mb-lg-5">
                <input value={data.password_confirm || ''} onChange={handleChange('password_confirm')} required maxLength="20" type="password" className="form-control" name="textBoxPassword2" id="textBoxPassword2" placeholder="Repetir contraseña" />
                {errors.password_confirm && <p className="error-form">{errors.password_confirm}</p>}
            </div>

            <p className="buttons text-center form-group mb-4 mb-lg-5">
                {isLoading
                    ?
                    <button type="submit" className="btn btn-primary btn-main no-hover hover-wong">
                        <Loading type="wong--hover" />
                    </button>
                    :
                    //<button className={"btn btn-primary btn-main no-hover hover-wong g-recaptcha"} data-sitekey={recaptcha.site_key} data-callback={'onSubmit'} data-action={recaptcha.action_register}>Aceptar</button>
                    <button className={`btn btn-primary btn-main ${btnDisabledAccept}  no-hover hover-wong g-recaptcha`} data-sitekey={recaptcha.site_key} data-callback={'onSubmit'} data-action={recaptcha.action_register}>Aceptar</button>
                }
            </p>
            <div >
            {/* //antiguo checkbox  <div className="form-group graystrong-on-hover">
                <label className="checkcontainer" htmlFor="checkBoxTerminos">
                    <input checked={data.conditions || false} onChange={handleChange('conditions')} type="checkbox" name="checkBoxTerminos" id="checkBoxTerminos" value="1" />
                    <span className={"checkmark "+((!!errors.conditions) && errors.conditions)}></span>
                    <label>
                    <a onClick={openTermConditions} id="terminos" >
                    He leido y acepto los Términos y Condiciones
                    </a>    
                    </label>
                </label>
            </div>
            <div className="form-group graystrong-on-hover">
                <label className="checkcontainer" htmlFor="checkBoxPolitica">
                    <input type="checkbox" name="checkBoxPolitica" id="checkBoxPolitica" value="1" />
                    <span className="checkmark"></span>
                    <label>
                    <a onClick={openTermConditions} id="politica">
                    He leído y acepto que mi información se utilizará conforme a las Politícas de Privacidad y seguridad
                    </a>    
                    </label>
                </label>
            </div> */}
            
            </div>
            <div>
                <input id="btn-submit" type={"submit"} style={{display:'none'}}></input>
            </div>
            <p className="legend graystrong-on-hover">Este sitio está protegido por reCAPTCHA. Se aplica la Política de privacidad y los Términos de servicio de Google.</p>
            {errorProcess!=='' && <p className="error-form text-center" style={{ paddingLeft: 0 }} dangerouslySetInnerHTML={{__html: errorProcess}}></p>}
            
        </form>
        <div className="col-12 ml-lg-auto mr-lg-auto mt-lg- mt-3">
                <TermPolCheckbox textId = "terminos"  onCheckboxClick={(isChecked) => handleCheckboxClick(isChecked, 'privacyPoliciesChecked')}
                 value={checkboxState.privacyPoliciesChecked} setValue={(value) =>
                    setCheckboxState({
                        ...checkboxState,
                        privacyPoliciesChecked: value,
                    })
                } showToolip={true}/>
            </div>
            <div className="col-12 ml-lg-auto mr-lg-auto mt-lg- mt-3">
                <TermPolCheckbox textId = "politica"   onCheckboxClick={(isChecked) => handleCheckboxClick(isChecked, 'termConditionsChecked')} 
                value={checkboxState.termConditionsChecked} setValue={(value) =>
                    setCheckboxState({
                        ...checkboxState,
                        termConditionsChecked: value,
                    })} showToolip={true}/>
            </div>
            <div className="col-12 ml-lg-auto mr-lg-auto mt-lg- mt-3">
                <TermPolCheckbox textId = "legal-others"  onCheckboxClick={(isChecked) => handleCheckboxClick(isChecked, 'legalOthersChecked')}  value={checkboxState.legalOthersChecked} 
                setValue={(value) =>
                            setCheckboxState({
                                ...checkboxState,
                                legalOthersChecked: value,
                            })
                        }  />
            </div>                  
        </>
    );
}

FormRegister.propTypes = {
    processData: PropTypes.func

};
export default FormRegister;